function IconPickerService() {
    const self = this;
    const fetchIcons = async () => {
        const response = await fetch('../hmodules/components/h-icon-picker/font-awesome-icons.json');
        return response.json();
    };
    const [getIcons, resetIcons] = cacheService.cache(fetchIcons);

    self.getIcons = getIcons;
    self.resetIcons = resetIcons;
}

angular
    .module("harriApp")
    .service("iconPickerService", IconPickerService);
IconPickerService.$inject = [];